import React, { useEffect, useState } from "react";
import { DonutChart, Spinner, Link } from "@abb/abb-common-ux-react";

import { ERROR_LIST } from "../../../strings";



import eventSummaryConfig from "./event-summary.json"
// Your provided mock data
const mockLoginData = [
    { Configuration: 7, Alarm: 4 },
    { Configuration: 7, Alarm: 5 },
    { Configuration: 3, Alarm: 4 },
    { Configuration: 2, Alarm: 2 },
    { Configuration: 4, Alarm: 4 },
    { Configuration: 5, Alarm: 5 }
];


function EventSummary() {
 

  const [isSpin, setIsSpin] = useState(true); // Renamed setispin to setIsSpin
  const [error, setError] = useState(false);
  const [data, setData] = useState([]);
  const [hiddenItems, setHiddenItems] = useState([]);
  const [hoverItem, setHoverItem] = useState();

  const processMockData = () => {
    setIsSpin(true); // Updated setispin to setIsSpin
    setError(false);

    let alarmTotal = 0;
    let configurationTotal = 0;

    mockLoginData.forEach(entry => {
      alarmTotal += entry.Alarm;
      configurationTotal += entry.Configuration;
    });

    const updatedData = [
      {
        key: eventSummaryConfig.EventTypes[0].key,
        value: alarmTotal,
        label: eventSummaryConfig.EventTypes[0].label,
        color: "#FF4C4C",
      },
      {
        key: eventSummaryConfig.EventTypes[1].key,
        value: configurationTotal,
        label: eventSummaryConfig.EventTypes[1].label,
        color: "#b85c00",
      },
    ].filter(item => item.value > 0);

    setData(updatedData);
    setIsSpin(false); // Updated setispin to setIsSpin
  };

  useEffect(() => {
    processMockData();
  }, []);

  const totalValue = data.reduce((sum, item) => sum + item.value, 0);

  let contentToRender;
  if (isSpin) {
    contentToRender = <Spinner style={{ margin: "auto" }} color="dark-grey" size="small" />;
  } else if (error) {
    contentToRender = (
      <span className="error-text">
        {ERROR_LIST.ERROR_FETCH_DATA}
        <br />
        <Link style={{ color: "#1f1f1f" }} onClick={processMockData}>
          Retry
        </Link>
      </span>
    );
  } else if (data?.length > 0) {
    contentToRender = (
      <DonutChart
        style={{
          width: "100%",
          padding: "20px 0px",
          margin: "0px 20px",
        }}
        legendPosition="right"
        allowValueHiding={true}
        disableHoverOnChart={false}
        disableHoverOnLegend={false}
        valueText={`${hoverItem ? hoverItem.value : totalValue}`}
        description={eventSummaryConfig.DonutChartProps.description}
        hiddenItems={hiddenItems}
        onHiddenItemsChanged={setHiddenItems}
        onHover={(item) =>
          setHoverItem(data.find((i) => i.key === item))
        }
        onBlur={() => setHoverItem(undefined)}
        data={data}
      />
    );
  } else {
    contentToRender = <p className="center-text-error">{ERROR_LIST.ALARM_SUMMARY_EMPTY_DATA}</p>;
  }


  return (
    <div className="event-summary-container">
      {contentToRender}
    </div>
  );
}

export default EventSummary;